import { getCookie } from "shared-utils/src/cookies";

export function getCSRFToken() {
  return getCookie("csrftoken");
}
